import { apiRequest, catchErrorMessageHandler } from "../../../infrastructure/backendService";
import {
  CommonOutlinedButton,
  CustomRequiredInputLabel,
  CustomTextFeildforFamily,
} from "../../common/StyledComponents/StyledFields";
import { useState } from "react";
import { Grid, Typography } from "@mui/material";
import { ValidationError, number, object, string } from "yup";
import styles from "../../contactUs/contactus.module.scss";
import ButtonLoader from "../../common/ButtonLoader/ButtonLoader";
import apiPath from "../../../config/apiPaths.json";
import ErrorPopup from "../../common/ErrorPopup";
import toast from "react-hot-toast";
import constants from "../../../config/constants.json";

interface ErrorMessageTypes {
  signInName: string | number;
}

const YearEndDonationReport = ({ sendDataToParent, getReportData }: any) => {
  const currentDate = new Date();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [year, setYear] = useState<string>("");
  const [formData, setFormData] = useState({
    signInName: "",
  });

  const [errorMessage, setErrorMessage] = useState<ErrorMessageTypes>({
    signInName: "",
  });

  const validationSchema = object().shape({
    signInName: string().required("Sign-In Name is required"),
  });
  const [loading, setLoading] = useState(false);

  const handleFieldChange = (field: string, value: any) => {
    setFormData({
      ...formData,
      [field]: value,
    });
  };

  const handleYearEndDonationReport = async () => {
    setLoading(true);
    apiRequest({
      method: "GET",
      endpoint: apiPath.donationReport,
      params: {
        yearOfDonations: `${currentDate.getFullYear() - 1}`,
        userName:formData.signInName?.toUpperCase()
      },
      includeToken: true,
    })
      .then(async (res) => {
        setLoading(false);
        sendDataToParent(true,formData);
        setYear(res.data.year);
        getReportData(res.data);
      })
      .catch((err) => {        
        setLoading(false);
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });

      });
  };

  const handleSave = async (): Promise<any> => {
    const errors: ErrorMessageTypes = {
      signInName: "",
    };
    try {
      // Validate the form data against the validation schema
      await validationSchema.validate(formData, { abortEarly: false });
      // If validation passes, you can submit the form
      setErrorMessage(errors);
      // Call your API or perform other actions here
      handleYearEndDonationReport();
    } catch (error) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e) => {
          if (e.path) {
            errors[e.path as keyof ErrorMessageTypes] = e.message;
          }
        });
      }
      setErrorMessage(errors);
    }
  };

  return (
    <Grid
      spacing={2}
      sx={{ display: "flex", flexDirection: "column", gap: "16px" }}
    >
      <Grid
        item
        xs={12}
        sm={4}
        className={styles.abhishekamReportsMainContainer}
      >
        {CustomRequiredInputLabel("Enter Sign-in name:", true)}
        <CustomTextFeildforFamily
          required
          value={formData.signInName}
          onChange={(e) => {
            setErrorMessage({ ...errorMessage, signInName: "" });
            handleFieldChange("signInName", e.target.value);
          }}
          className={
            errorMessage.signInName ? styles.errorTextField : styles.textField
          }
        />
        {errorMessage.signInName && (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessage.signInName}
          </Typography>
        )}
      </Grid>
      <CommonOutlinedButton
        sx={{ width: "fit-content", height: "38px" }}
        onClick={handleSave}
        disabled={loading}
        id="submit"
      >
        <ButtonLoader isBtnLoading={loading} btnText={"Submit"} />
      </CommonOutlinedButton>
    </Grid>
  );
};
export default YearEndDonationReport;
